import { render, staticRenderFns } from "./CryptoIconItem.vue?vue&type=template&id=4cf4abad"
import script from "./CryptoIconItem.vue?vue&type=script&lang=js"
export * from "./CryptoIconItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports